import getApiInstance from '@/api';
import { type BookingSearchRequestDTO } from '@/types/dto/agent';

export const fetchProfileBookings = async (
  request: Omit<
    BookingSearchRequestDTO,
    'purchaserPassengerEmail' | 'concessionVoucherSearchType'
  >
) => {
  const api = (await getApiInstance()).agentApi;

  //TODO handle pagination if needed
  const { bookingsSearchResults } = (
    await api.BookingsSearch_SearchBookingsCustom(null, {
      concessionVoucherSearchType: 'ALL',
      ...request,
    })
  ).data;

  return bookingsSearchResults ?? [];
};
